const SESSION_COOKIE_NAME = "edgeProSessionToken";
const LOGOUT_MARKER_COOKIE = "edgeProSessionLogout";
const SESSION_MAX_AGE_SEC = 60 * 60 * 24 * 7;
const LOGOUT_MARKER_MAX_AGE_SEC = 60 * 60 * 24;

function getCookieDomain(): string | undefined {
  const host = window.location.hostname.toLowerCase();
  if (host === "localhost" || host === "127.0.0.1") {
    return undefined;
  }
  if (host.endsWith("gsevenpro.com")) {
    return ".gsevenpro.com";
  }
  return undefined;
}

function parseStoredToken(raw: string | null): string {
  if (!raw) return "";
  const trimmed = String(raw).trim();
  if (!trimmed) return "";
  try {
    const parsed = JSON.parse(trimmed);
    return typeof parsed === "string" ? parsed : trimmed;
  } catch {
    return trimmed;
  }
}

function writeCookie(name: string, value: string, maxAgeSec: number) {
  const domain = getCookieDomain();
  const secure = window.location.protocol === "https:" || window.location.hostname.toLowerCase() === "localhost";
  let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSec}; samesite=lax`;
  if (domain) {
    cookie += `; domain=${domain}`;
  }
  if (secure) {
    cookie += "; secure";
  }
  document.cookie = cookie;
}

function clearCookie(name: string) {
  const domain = getCookieDomain();
  const secure = window.location.protocol === "https:" || window.location.hostname.toLowerCase() === "localhost";
  let cookie = `${name}=; path=/; max-age=0; samesite=lax`;
  if (domain) {
    cookie += `; domain=${domain}`;
  }
  if (secure) {
    cookie += "; secure";
  }
  document.cookie = cookie;
}

export function setSessionTokenCookie(token: string) {
  const normalized = parseStoredToken(token);
  if (!normalized) return;

  clearLogoutMarkerCookie();
  writeCookie(SESSION_COOKIE_NAME, normalized, SESSION_MAX_AGE_SEC);
}

export function clearSessionTokenCookie() {
  clearCookie(SESSION_COOKIE_NAME);
  setLogoutMarkerCookie();
}

export function setLogoutMarkerCookie() {
  writeCookie(LOGOUT_MARKER_COOKIE, String(Date.now()), LOGOUT_MARKER_MAX_AGE_SEC);
}

export function clearLogoutMarkerCookie() {
  clearCookie(LOGOUT_MARKER_COOKIE);
}

export function syncSessionCookieFromStorage() {
  const token = parseStoredToken(localStorage.getItem("edgeProAccessToken"));
  if (token) {
    setSessionTokenCookie(token);
  }
}

export function isAllowedBillAuditReturnUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase();
    if (host === "billaudit.gsevenpro.com") {
      return parsed.protocol === "https:";
    }
    if (host === "localhost" || host === "127.0.0.1") {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

/** Tell Bill Audit tabs/iframes that the GSevenPro session ended. */
export function broadcastBillAuditLogout() {
  if (typeof window === "undefined") return;

  const message = { type: "SESSION_LOGOUT" };

  document.querySelectorAll("iframe").forEach((iframe) => {
    try {
      iframe.contentWindow?.postMessage(message, "*");
    } catch {
      // no-op
    }
  });

  try {
    window.postMessage(message, "*");
  } catch {
    // no-op
  }
}
